<template>
  <div>
    <nav-breadcrumb :menu="[{label: '参数设置'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <form-build-component
        label-width="300px"
        form-name="ConfigSettingFinancing"
        :form-data="formData"
        :form-columns-group="formColumnsGroup"
        :form-rules="formRules"
        :form-buttons="formButtons"
        style="width:600px"
      ></form-build-component>
    </el-row>
  </div>
</template>

<script>
  import FormBuildComponent from "../../../components/FormBuild";
  import xhr from "../../../utils/xhr";
  export default {
    name: 'ConfigSettingFinancing',
    components: {FormBuildComponent},
    data() {
      return {
        formData: {
          'financing-setting__threshold__perTx': '',
          'financing-setting__threshold__perCx': '',
          'financing-setting__threshold__daily': '',
          'repayment-setting__standard__OverdueDailyFineRate': '',
          'payment-setting__threshold__perTx': '',
          'payment-setting__threshold__perCx': '',
          'payment-setting__threshold__daily': '',
        },
        formColumnsGroup: [
          {
            label: '提款规则',
            columns: [
              {
                label: '每日每人单笔提款免审核限额',
                component: 'el-input',
                unit: '元',
                field: 'financing-setting__threshold__perTx',
                span: 24
              },
              {
                label: '每人单日提款免审核限额',
                component: 'el-input',
                unit: '元',
                field: 'financing-setting__threshold__perCx',
                span: 24
              },
              {
                label: '单日免审核提款限额',
                component: 'el-input',
                unit: '元',
                field: 'financing-setting__threshold__daily',
                span: 24
              }
            ]
          },
          {
            label: '罚息比例',
            columns: [
              {
                label: '罚息自到期日后起按本金的每日万分之',
                component: 'el-input',
                unit: '‱',
                field: 'repayment-setting__standard__OverdueDailyFineRate',
                span: 24
              },
            ]
          },
          {
            label: '放款规则',
            columns: [
              {
                label: '每日每人单笔放款免审核限额',
                component: 'el-input',
                unit: '元',
                field: 'payment-setting__threshold__perTx',
                span: 24
              },
              {
                label: '每人单日放款免审核限额',
                component: 'el-input',
                unit: '元',
                field: 'payment-setting__threshold__perCx',
                span: 24
              },
              {
                label: '单日自动放款限额',
                component: 'el-input',
                unit: '元',
                field: 'payment-setting__threshold__daily',
                span: 24
              }
            ]
          },
        ],
        formRules: {
          'financing-setting__threshold__perTx': [
            {
              required: true,
              message: '此项必填！'
            }
          ],
          'financing-setting__threshold__perCx': [
            {
              required: true,
              message: '此项必填！'
            }
          ],
          'financing-setting__threshold__daily': [
            {
              required: true,
              message: '此项必填！'
            }
          ],
          'repayment-setting__standard__OverdueDailyFineRate': [
            {
              required: true,
              message: '此项必填！'
            }
          ],
          'payment-setting__threshold__perTx': [
            {
              required: true,
              message: '此项必填！'
            }
          ],
          'payment-setting__threshold__perCx': [
            {
              required: true,
              message: '此项必填！'
            }
          ],
          'payment-setting__threshold__daily': [
            {
              required: true,
              message: '此项必填！'
            }
          ],
        },
        formButtons: [
          {
            label: '保存',
            type: 'primary',
            clickHandler:$refs=>{
              $refs.validate(valid => {
                if(valid) {
                  this.updateMerchantConfig()
                }
                else {

                }
              })
            }
          }
        ]
      }
    },
    mounted() {
      this.getMerchantConfig()
    },
    methods: {
      getMerchantConfig: function () {
        xhr.getMerchantConfig(
          {
            pageSize: 999
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                res.data.data.map(item=>{
                  let pref__preferenceKey = item.pref__preferenceKey.replace(/\./g, '__')
                  if(this.formData.hasOwnProperty(pref__preferenceKey)) {
                    this.formData[pref__preferenceKey] = item.pref__preferenceValue
                  }
                })

                console.log(this.formData)
              }

            }catch (e) {

            }
          }
        )
      },
      updateMerchantConfig: function () {
        Object.keys(this.formData).forEach(key=>{
          xhr.updateMerchantConfig(
            {
              'pref.preferenceKey' : key.replace(/__/g, '.'),
              'pref.preferenceValue' : Number(this.formData[key])||0
            },
            res=>{

            }
          )
        })
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/lender/setting/ConfigSettingFinancing.vue